export default __webpack_public_path__ + "static/logo-7017a20c089080856279a989fb13cfdf.svg";